module.exports = __webpack_public_path__ + "static/fonts/NotoSans-DemiLight.0cebeac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-DemiLight.woff
// module id = hfwk
// module chunks = 0